import BaseService from "../BaseService";
import { API_BASE_URL_ENV } from "../../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/employee-type";

export default class JobTypeService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
